var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRow21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 49,
    viewBox: "0 0 37 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_2027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.49 42.0102H22.19L20.76 38.1802C19.89 38.3102 18.99 38.3902 18.08 38.3902C17.17 38.3902 16.27 38.3202 15.39 38.1902L13.96 42.0202H9.67C7.3 42.0202 5.37 43.9402 5.37 46.3202V48.6502H30.79V46.3202C30.79 43.9402 28.87 42.0202 26.5 42.0202L26.49 42.0102Z",
    fill: "#22499D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.08 0C8.09 0 0 8.09 0 18.08C0 28.07 8.09 36.16 18.08 36.16C28.07 36.16 36.16 28.07 36.16 18.08C36.16 8.09 28.06 0 18.08 0ZM18.08 25.62C13.92 25.62 10.54 22.24 10.54 18.08C10.54 13.92 13.92 10.54 18.08 10.54C22.24 10.54 25.62 13.92 25.62 18.08C25.62 22.24 22.24 25.62 18.08 25.62Z",
    fill: "#22499D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.08 13.8599C15.75 13.8599 13.87 15.7499 13.87 18.0699C13.87 20.3899 15.76 22.2799 18.08 22.2799C20.4 22.2799 22.29 20.3899 22.29 18.0699C22.29 15.7499 20.41 13.8599 18.08 13.8599Z",
    fill: "#22499D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_2027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.15,
    height: 48.63,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow21);
export default __webpack_public_path__ + "static/media/row2-1.7b4912f879f747ae64710b9ee43c2787.svg";
export { ForwardRef as ReactComponent };